import isNumber from './utils/isNumber';
import separateThousands from './utils/separateThousands';

const NUMBER_OF_CENTS_IN_A_EURO = 100;

/**
 * Converts a number denoting cents into a formatted price with dutch specific locale settings.
 * @see http://www.sacah.net/2011/01/javascript-format-number-price-amount.html
 *
 * @param cents Value in cents instead of euros
 * @param withEuroSign Prefix euro sign separated with non-breaking space
 * @param suppressZeroCents replace ,00 with ,-
 */
export default function currency(
  cents: string | number,
  withEuroSign: boolean = false,
  suppressZeroCents: boolean = false,
): string {
  if (!isNumber(cents)) {
    return `${cents}`;
  }

  let price = String(Number(cents) / NUMBER_OF_CENTS_IN_A_EURO)
    .replace(/(\.\d{2})[\W\w]+/g, '$1')
    .replace(/^([-]{0,1}),/, '$1')
    .replace(/(\.\d)$/, '$10')
    .replace(/\.$/, '.00')
    .replace(/\./g, ',');

  price = separateThousands(price);

  if (price.indexOf(',') === -1) {
    price = `${price},00`;
  }

  if (withEuroSign) {
    // non-breaking space
    price = `€\u00a0${price}`;
  }

  if (suppressZeroCents) {
    price = price.replace(',00', ',-');
  }

  return price;
}
